import { PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js"
import PropTypes from "prop-types"
import React, { useEffect } from "react"

import Form from "src/components/Form"
import Modal from "src/components/Modal"
import StripeElements, { StripeLoadError } from "src/components/StripeElements"

import {
  cancelPaymentMethodSetup,
  initializePaymentMethodSetup,
} from "src/api/Account/PaymentMethods"

import useSetupIntent from "src/hooks/payment_method_hooks/use_setup_intent"
import useStripeForm from "src/hooks/payment_method_hooks/use_stripe_form"

const AddPaymentMethodModal = ({ isOpen, onClose, setLoading }) => {
  const acceptedPaymentMethods = ["card", "us_bank_account"]
  const allowMicrodepositVerification = true
  const { activeSetupIntent, isLoading } = useSetupIntent(
    isOpen,
    acceptedPaymentMethods,
    allowMicrodepositVerification,
    initializePaymentMethodSetup,
    cancelPaymentMethodSetup
  )

  useEffect(() => {
    setLoading(isLoading)
  }, [setLoading, isLoading])

  return (
    activeSetupIntent && (
      <StripeElements
        inlineLoadError={false}
        options={{
          clientSecret: activeSetupIntent.clientSecret,
        }}
      >
        <ModalContent isOpen={isOpen} onClose={onClose} />
      </StripeElements>
    )
  )
}

// We are forced to separate this component because the Elements component must
// wrap any component that uses the useStripe and useElements hooks.

const ModalContent = ({ isOpen, onClose }) => {
  const stripe = useStripe()
  const elements = useElements()

  const { handleSubmit, handleChange, isSubmitting, error, complete } =
    useStripeForm({ stripe, elements })

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="mediumFixed">
      <Modal.Body>
        <StripeLoadError />
        <form className="mt-8 px-2">
          <PaymentElement
            options={{ layout: { type: "tabs" } }}
            onChange={handleChange}
          />
          {complete && error && <Form.Error>{error.message}</Form.Error>}
        </form>
      </Modal.Body>
      <Modal.Footer
        onClose={onClose}
        onSubmit={handleSubmit}
        confirmBtnLoading={isSubmitting}
      />
    </Modal>
  )
}

AddPaymentMethodModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
}

ModalContent.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default AddPaymentMethodModal
